"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _utils = require("../utils/utils");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var useWindowResize = function useWindowResize(handler, breakpoints) {
  var getBreakpointWindows = function getBreakpointWindows(breakpoints) {
    var sortedBreakpoints = [0].concat(_toConsumableArray(breakpoints.slice(0).sort(function (a, b) {
      return a - b;
    })), [100000]);
    var breakpointWindows = [];
    for (var i = 0; i < sortedBreakpoints.length - 1; i++) {
      breakpointWindows.push({
        min: sortedBreakpoints[i],
        max: sortedBreakpoints[i + 1]
      });
    }
    return breakpointWindows;
  };
  var breakpointWindows = getBreakpointWindows(breakpoints);
  var lastBreakpoint = null;
  var currentBreakpoint = function currentBreakpoint() {
    for (var i = 0; i < breakpointWindows.length; i++) {
      if (window.innerWidth > breakpointWindows[i].min && window.innerWidth <= breakpointWindows[i].max) {
        return breakpointWindows[i];
      }
    }
    return null;
  };
  var listener = (0, _utils.debounceEvent)(function () {
    if (lastBreakpoint != currentBreakpoint()) {
      lastBreakpoint = currentBreakpoint();
      handler();
    }
  }, 250);
  (0, _react.useEffect)(function () {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", listener);
      lastBreakpoint = currentBreakpoint();
      handler();
      return function () {
        window.removeEventListener("resize", listener);
      };
    }
  }, []);
};
var _default = exports["default"] = useWindowResize;